/**
 * @generated SignedSource<<96d9d272fd12bc8b674468602bb4d3bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ModifySubscriptionLinkMutation$variables = {
  name: string;
};
export type ModifySubscriptionLinkMutation$data = {
  readonly modifySubscriptionLink: {
    readonly url: string;
  } | null | undefined;
};
export type ModifySubscriptionLinkMutation = {
  response: ModifySubscriptionLinkMutation$data;
  variables: ModifySubscriptionLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "organization",
        "variableName": "name"
      }
    ],
    "concreteType": "ModifySubscriptionLink",
    "kind": "LinkedField",
    "name": "modifySubscriptionLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ModifySubscriptionLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ModifySubscriptionLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fe03be4d970f77d95138528acc52dfa4",
    "id": null,
    "metadata": {},
    "name": "ModifySubscriptionLinkMutation",
    "operationKind": "mutation",
    "text": "mutation ModifySubscriptionLinkMutation(\n  $name: String!\n) {\n  modifySubscriptionLink(organization: $name) {\n    url\n  }\n}\n"
  }
};
})();

(node as any).hash = "e8f94a60a6da23f34f2655ad4f2c5a00";

export default node;
